import React from "react";

const Hero = ({ children }) => {
  return (
    <div
      style={{
        backgroundImage: `url("bannerbg.jpeg")`,
        height: 370,

        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        display: "flex",
      }}
    >
      <div
        style={{ backgroundColor: "#003a31b3" }}
        className="w-full h-full bg-opacity-50"
      >
        {children}
      </div>
    </div>
  );
};

export default Hero;
